export default __webpack_public_path__ + "static/media/wedding-thumbnail-4.593d3db2.jpg";